export class FiltrosComprobanteElectronico{
    Opc : string ="PDC";
    pidDesembolso :string = '';
    IdProv : string ='';
    IdAdqui : string = '';
    pMoneda : number = 0;
    Estado : string = 'D';
    
 }